import { useState } from "react";

import { t } from "../../../i18n";
import { Button, DropdownMenu, highlightMatch, TapTarget } from "../../ui";

/**
 * Beskrivelsen i kort-radet bruker `truncate` for a unnga at lange
 * tekster sprer kortet ut. Denne komponenten gjor teksten klikkbar —
 * popover viser full beskrivelse med kopier-knapp. Tar ikke ekstra
 * plass i raden.
 */
export function CopyableDescription({
  description,
  search,
}: {
  description: string;
  search: string;
}) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(description);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API kan feile pa eldre nettlesere eller uten HTTPS — vi
      // sluker feilen stille; brukeren kan velge teksten manuelt fra popoveren.
    }
  };

  return (
    <DropdownMenu
      align="start"
      trigger={
        <TapTarget className="block w-full truncate rounded-sm text-left font-medium text-ink-900 text-sm hover:text-ink-700">
          {highlightMatch(description, search)}
        </TapTarget>
      }
    >
      <div className="flex max-w-[20rem] flex-col gap-2 px-3 py-2">
        <p className="whitespace-pre-wrap break-words text-ink-900 text-sm">{description}</p>
        <Button
          size="sm"
          variant="secondary"
          iconLeft={copied ? "check" : "copy"}
          onClick={copy}
          className="self-start"
        >
          {copied
            ? t.settlement.expenses.descriptionPopover.copied
            : t.settlement.expenses.descriptionPopover.copy}
        </Button>
      </div>
    </DropdownMenu>
  );
}
